/* eslint-disable indent */
import Vue from 'vue';
import VueRouter, { Route } from 'vue-router';
import { moduleProxy } from '@/store';
import { HeaderModel } from '../models/headerModel';
import routes from './routes';

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

// Guards
router.beforeEach((to, from, next) => {
    // Hide the main alert before the route changes.
    moduleProxy.mainAlert.hide();
    next();
});

router.afterEach((to: Route) => {
    // Update the breadcrumbs component.
    moduleProxy.BreadCrumb.updateBreadCurmbs(to);
    if (to.name === 'partners') {
        moduleProxy.Stepper.setActiveFirstPartnerStep();
    } else if (to.name === 'contractDuration') {
        moduleProxy.Stepper.setActiveContractDurationStepStep();
    } else if (to.name === 'contractData') {
        moduleProxy.Stepper.setActiveContractDataStep();
    } else if (to.name === 'previewContract') {
        moduleProxy.Stepper.setActiveReviewContractStep();
    } else {
        moduleProxy.Stepper.hideStepper(true);
    }

    const headerModel = {} as HeaderModel;
    moduleProxy.Header.setHeaderData(headerModel);
});

export default router;
